import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Textarea } from "@/components/ui/textarea";
import { pluralize } from "@/utils/text";
import { VideoInfoBox } from "./video-info-box";

type TicketFormFieldsProps = {
  form: any;
  disabled?: boolean;
  videoCount: number;
  ticketType: "demonetization" | "takedown";
  videos: Array<{ videoId: string; thumbnail: string | null }>;
};

export const TicketFormFields = ({ form, disabled, videoCount, ticketType, videos }: TicketFormFieldsProps) => {
  const actionName = ticketType === "demonetization" ? "demonetized" : "taken down";
  const message = `This request will be sent for ${pluralize(videoCount, "video", "videos")} in total to TikTok`;

  return (
    <>
      <FormField
        control={form.control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Reason for request</FormLabel>
            <FormControl>
              <Textarea rows={5} {...field} disabled={disabled} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {videoCount > 1 && <VideoInfoBox videos={videos} message={message} />}

      {videoCount > 1 && (
        <FormField
          control={form.control}
          name="groupRequests"
          render={({ field }) => (
            <FormItem className="space-y-3">
              <FormControl>
                <RadioGroup
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                  className="flex flex-col gap-2"
                  disabled={disabled}
                >
                  <div
                    className={`flex items-start gap-3 p-4 rounded-xl bg-primary ${
                      field.value === "grouped" ? "border-2 border-brand" : "border border-secondary"
                    }`}
                  >
                    <RadioGroupItem value="grouped" id="grouped" className="mt-0.5" />
                    <Label htmlFor="grouped" className="text-base font-medium text-secondary cursor-pointer flex-1">
                      Group requests into one Ticket
                    </Label>
                  </div>
                  <div
                    className={`flex items-start gap-3 p-4 rounded-xl bg-primary ${
                      field.value === "individual" ? "border-2 border-brand" : "border border-secondary"
                    }`}
                  >
                    <RadioGroupItem value="individual" id="individual" className="mt-0.5" />
                    <Label htmlFor="individual" className="text-base font-medium text-secondary cursor-pointer flex-1">
                      Send each request as an individual Ticket
                    </Label>
                  </div>
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </>
  );
};
